// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page__header {
  box-shadow: 0 50px 50px 0 #F8FBF7, 0 2px 0 0 #F2F6F0;
  margin: 20px 0;
  padding-bottom: 20px;
}
.home-page__separator {
  background: #e2e2ea;
  height: 1px;
  left: 0;
  position: absolute;
  top: 152px;
  width: 100%;
}
@media screen and (max-width: 767px) {
  .home-page__separator {
    top: 130px;
  }
}
.home-page__table {
  margin-top: 20px;
  border-radius: 6px;
  min-width: 500px;
  text-align: left;
}
.home-page__table-cell {
  border-bottom: 1px solid #e2e2ea;
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/index.scss","webpack://./node_modules/@ergeon/core-components/src/components/variables.default.scss"],"names":[],"mappings":"AAGE;EACE,oDAAA;EACA,cAAA;EACA,oBAAA;AAFJ;AAIE;EACE,mBCWK;EDVL,WAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAFJ;ACqOE;EDzOA;IAQI,UAAA;EAAJ;AACF;AAEE;EACE,gBC8DG;ED7DH,kBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AACI;EACE,gCAAA;EACA,aAAA;AACN","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
